<template>
  <b-form @submit.prevent="save">
    <b-row>
      <b-col md="6" >
        <b-form-group :label="$t('FIRST_NAME')">
          <b-form-input v-model="userData.first_name" type="text"></b-form-input>
          <validation-description :show="$v.userData.first_name.$dirty && $v.userData.first_name.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group :label="$t('LAST_NAME')">
          <b-form-input v-model="userData.last_name"  type="text"></b-form-input>
          <validation-description :show="$v.userData.last_name.$dirty && $v.userData.last_name.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label="Email">
          <b-form-input v-model="userData.email"  type="text"></b-form-input>
          <validation-description :show="$v.userData.email.$dirty && $v.userData.email.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group :label="$t('ROLES')">
          <b-form-select v-model="userData.role" @change="disabledInstitution">
            <option :value="null">-</option>
            <option :key="index" v-for="(role, index) in roles" :value="role.id">
              {{ role.name }}
            </option>
          </b-form-select>
          <validation-description :show="$v.userData.role.$dirty && $v.userData.role.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group :label="$t('LANGUAGE')">
          <b-form-select v-model="userData.preferred_language" :options="language_options">
          </b-form-select>
          <validation-description :show="$v.userData.preferred_language.$dirty && $v.userData.preferred_language.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group :label="$t('ECONOMY')">
          <b-form-select v-model="userData.economy_id" >
            <option :value="null">-</option>
            <option :key="index" v-for="(economy, index) in economics" :value="economy.id">
              {{economy.name}}
            </option>
          </b-form-select>
          <validation-description :show="$v.userData.economy_id.$dirty && $v.userData.economy_id.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group :label="$t('INSTITUTION')">
          <b-form-select v-model="userData.institution_id" :disabled="disabledInstitution()">
            <option :value="null">-</option>
            <option :key="index" v-for="(institution, index) in institutions" :value="institution.id">
              {{institution.name}}
            </option>
          </b-form-select>
          <validation-description v-if="!disabledInstitution()" :show="$v.userData.institution_id.$dirty && $v.userData.institution_id.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col sm="6" md="6" lg="6">
        <app-button-submit :loading="loading" :c_permission="C_USER_SAVE_BUTTON"></app-button-submit>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
  import AppButtonSubmit from '@/components/app/AppSubmit'
  import ValidationDescription from '@/components/app/form/AppValidationDescription'
  import {getInstitutionList} from "@/services/institution"
  import {getEconomyList} from "@/services/economy"
  import {getRoleList} from "@/services/role"
  import {required} from 'vuelidate/lib/validators'
  import i18n from '@/locale/index'
  import {createUser} from "@/services/user"
  import {toast} from "@/shared/plugins/toastr"
  import {getErrorMessage} from "@/mixins/error/getErrorMessage"
  import {C_USER_SAVE_BUTTON} from "@/shared/component_permission"
  import enumeration from "@/store/enumeration"

  export default {
      name: "UserNewForm",
      mixins:[getErrorMessage],
      data() {
        return {
          languages:[
            {value:'sr', text: i18n.t('SR')},
            {value:'hr', text: i18n.t('HR')},
            {value:'bs', text: i18n.t('BS')}
          ],
          options_status:[
            {value:1, text: i18n.t('ACTIVE')},
            {value:0, text: i18n.t('NOTACTIVE')}
          ],
          institutions:[],
          economics:[],
          roles:[],
          userData: {
            first_name: null,
            last_name: null,
            email: null,
            preferred_language: null,
            institution_id: null,
            economy_id: null,
            role:null,
            active:1,
          },
          C_USER_SAVE_BUTTON,
          loading:false,
          language_options:[
          {
            value:'en',text:this.$t('ENGLISH'),
          },
          {
            value:'sr',text:this.$t('SERBIAN'),
          },
          {
            value:'bs',text:this.$t('BOSNIAN_BOS'),
          },
          {
            value:'hr',text:this.$t('BOSNIAN_HRV'),
          },
          {
            value:'sr',text:this.$t('BOSNIAN_SRP'),
          },
          {
            value:'en',text:this.$t('MACEDONIAN'),
          },
          {
            value:'en',text:this.$t('ALBANIAN'),
          },
          {
            value:'bs',text:this.$t('MONTENEGRO'),
          }
          ],
        }
      },
      components:{
        ValidationDescription,
        AppButtonSubmit
      },
      validations(){
        return this.disabledInstitution()
        ? {
          userData:{
            first_name:{required},
            last_name:{required},
            email:{required},
            preferred_language:{required},
            economy_id: {required},
            role:{required},

            }
          }
        : {
          userData:{
          first_name:{required},
          last_name:{required},
          email:{required},
          preferred_language:{required},
          economy_id: {required},
           role:{required},
          institution_id: {required}
         }
        }
      },
      methods: {
        getInstitutions(id) {
          getInstitutionList({economy:id})
            .then(response => {
              this.institutions = response.data
            })
        },
        getEconomies() {
          getEconomyList()
             .then(response => {
               this.economics = response.data
            })
        },
        getRoles() {
          let roleList = []
          getRoleList()
             .then(response => {
               roleList = response.data
               this.roles = roleList.slice(1,4)
            })
        },
        disabledInstitution() {
          if(this.userData.role === enumeration.economy_view_role) {
           return true
          }
           return false
        },

        save() {
          this.$v.userData.$touch()
          if(this.$v.userData.$invalid){
            toast({
              'title': this.$t('VALIDATION_FAILED'),
              'message': null,
              'type': 'error',
              'timeout': 4000
            })
            return
          }
          this.loading = true
          createUser(this.userData).then(() => {
            toast({
                title: this.$t('NOTIFICATIONS.SAVE_SUCCESS.TITLE'),
                message: this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
                'type': 'success',
                'timeout': 2000
              })
              this.$store.dispatch('user/actionSearch')
              this.$emit('closePanel', this.editAsidePanel)
          }, error => {
            toast({
              title: this.$t('NOTIFICATIONS.SAVE_ERROR.TITLE'),
              message: this.$t('NOTIFICATIONS.SAVE_ERROR.MESSAGE', {value: this.getMessages(error)}),
              'type': 'error',
              'timeout': 6000
            })
          }).finally(()=>{
            this.loading = false
          })
        },
      },
      computed: {
        language(){
           return localStorage.getItem('language') ? localStorage.getItem('language') : 'hr'
        }
      },
      watch:{
          'userData.economy_id':{
            handler(value){
                this.getInstitutions(value)
            }
          }
      },
      async mounted (){
        await this.getEconomies();
        await this.getRoles();
      }
    }
</script>

<style scoped>

</style>
